import styled from "styled-components";

export const StatisticsContainer = styled.div`
  box-shadow: 2px 2px 6px 0px #5e5e5e;
  padding: 15px;
  border: 3px outset #643E91;
  width: 100%;
  height: 75vh;
`